import React, { Component } from 'react';
export function Header() {
  const handleWhatsApp = () => {
    // Track Lead event
    if (window.fbq) {
      window.fbq('track', 'Lead');
    }
    const message = encodeURIComponent('Hola, Cotizar');
    window.open(`https://wa.me/573182434499?text=${message}`, '_blank');
  };
  return <header className="fixed top-0 left-0 right-0 z-50 bg-[#1A1A1A]/95 backdrop-blur-sm border-b border-white/10" data-id="element-69">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-3 md:py-4 flex items-center justify-between" data-id="element-70">
        <div className="flex items-center" data-id="element-71">
          <span className="text-xl md:text-2xl font-black text-white tracking-tight" data-id="element-72">
            GERFAJ
          </span>
          <span className="ml-2 text-xs text-white/60 font-light" data-id="element-73">S.A.S.</span>
        </div>
        <button onClick={handleWhatsApp} className="bg-[#E8621A] text-white px-6 md:px-8 py-3 rounded-full font-bold uppercase text-[13px] md:text-[15px] hover:bg-[#d55515] transition-colors shadow-lg shadow-[#E8621A]/20 min-h-[44px]" style={{
        lineHeight: '1',
        letterSpacing: '0.08em'
      }} data-id="element-74">
          Cotizar
        </button>
      </div>
    </header>;
}